const CategoryCard = ({ category, handleCategoryClick, updateTimestamp }: any) => {
  // Add timestamp to image URL to prevent caching issues
  const imageUrl = category.image 
    ? `${category.image}${category.image.includes('?') ? '&' : '?'}t=${updateTimestamp}`
    : category.image;

  return (
    <button
      className="border m-3 p-3 rounded-lg w-56 cursor-pointer hover:shadow-lg transition-shadow"
      onClick={() =>
        handleCategoryClick(category._id, category.type, category.image)
      }
    >
      <div className="flex items-center justify-between">
        <p className="text-sm my-2 text-left font-semibold text-secondary">
          {category.type.toUpperCase()}
        </p>
        <p>{category.amountOfProduct || 0}</p>
      </div>
      <div className="w-full h-32 rounded-md bg-gray-50 flex items-center justify-center">
        <img
          key={category.image}
          src={imageUrl}
          className="w-full h-full rounded-md object-contain"
          alt={category.type}
        />
      </div>
    </button>
  );
};

export default CategoryCard;
